import * as e from "react";
import { useFormContext as r, get as n } from "react-hook-form";
var s = function s(_s) {
  var t = _s.as,
    a = _s.errors,
    m = _s.name,
    o = _s.message,
    i = _s.render,
    l = function (e, r) {
      if (null == e) return {};
      var n,
        s,
        t = {},
        a = Object.keys(e);
      for (s = 0; s < a.length; s++) r.indexOf(n = a[s]) >= 0 || (t[n] = e[n]);
      return t;
    }(_s, ["as", "errors", "name", "message", "render"]),
    f = r(),
    c = n(a || f.formState.errors, m);
  if (!c) return null;
  var g = c.message,
    u = c.types,
    d = Object.assign({}, l, {
      children: g || o
    });
  return e.isValidElement(t) ? e.cloneElement(t, d) : i ? i({
    message: g || o,
    messages: u
  }) : e.createElement(t || e.Fragment, d);
};
export { s as ErrorMessage };